/*----- Core -----*/
import { takeLatest, put, call } from 'redux-saga/effects'
import { push }           			 from 'connected-react-router'
/*----- Components -----*/
import Notification from "../../../../components/commons/Notification"

/*----- Constants -----*/
import {
 	UPDATE_PRODUCER,
  UPDATE_PRODUCER_SUCCESS,
	UPDATE_PRODUCER_FAIL
} from './Constants'

import { PRODUCERS, PROFILE_PICS } from '../../../app/Constants'

/*----- Firestore -----*/
import { db } from '../../../../Firebase'
import imageLoader from '../../../imageLoader'

// /*----- Constants -----*/
const COLLECTION_NAME = PRODUCERS

function* shootUpdateproducer(action) {

	let { body, newImages, producer_id } = action.payload

	function* updateProduct() {
		try {
			let modifiedBody = body

			if (newImages) {
				const imageUrl = yield imageLoader(newImages, `${ PROFILE_PICS }/${ producer_id }.jpg`)
				yield modifiedBody = {
					...body,
					...modifiedBody,
					images: imageUrl
				}
			}

			yield db.collection(COLLECTION_NAME)
						.doc(producer_id)
						.update(modifiedBody)
			yield put({type: UPDATE_PRODUCER_SUCCESS, payload: {...modifiedBody } })
			yield Notification('Productor actualizado', 'success')
			yield put(push('/'))

		} catch (error) {
			yield Notification(error.message, 'error')
			yield console.log(error.message)
		}
	}
	try {
		yield call(updateProduct)
		/*** Success creation then run a system log ***/
	} catch (error) {
		yield put({type: UPDATE_PRODUCER_FAIL, payload: error.message})
		yield console.log(error.message)
		yield body = error.message
		yield Notification(error.message, 'error')
	}
}
export default function* updateProducteWatcher() {
  yield takeLatest(UPDATE_PRODUCER, shootUpdateproducer)
}
